export default __webpack_public_path__ + "static/media/InsideEyes_02.1c00b7d1.png";